import chatTicketCosts from "@/http/requests/chatTicketCosts";

export default {
  fetch({ commit }, search = '') {
    return new Promise((resolve, reject) => {
      chatTicketCosts.fetch(search).then(response => {

        commit('SET_CHAT_TICKET_COSTS', response.data.data.chatTicketCosts.items);
        commit('SET_COSTS_BY_TYPES', response.data.data.chatTicketCosts.sum_costs_by_type);
        commit('SET_CHAT_TICKET_COSTS_BY_TYPES', { type: 'chatTicketTypes', collumn: 'ticket_is_open'});

        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  setChatTicketCostsByTypes({ commit }, { type, collumn }){
    commit('SET_CHAT_TICKET_COSTS_BY_TYPES', { type, collumn });
  },
  setChatTicketCostsByOpen({ commit }){
    commit('SET_CHAT_TICKET_COSTS_BY_TYPES', { type: 'chatTicketTypes', collumn: 'ticket_is_open' });
  }
}
